export default {



  subtitle: "Our Journey",
  title: "Our Story: Transforming Modern Language Education",
  paragraph1:
    "Undoubtedly, the new generation—known as the digital generation—is more connected to the internet than ever before and meets a significant part of their needs online. Naturally, the future of education will follow the same path. We strive to pioneer this shift in language learning, turning our 20 years of experience into an adventurous journey for children in Iran.",
  paragraph2:
    "Our companions on this journey are kids and teens aged 4 to 14, experiencing a colorful, stress-free learning journey designed to bring a complete language school right into their rooms via the digital world.",
  expNumber: "20+ Years",
  expLabel: "Teaching Experience",
  ageNumber: "4 to 14 Years",
  ageLabel: "Target Age Group",
  pillText: "Language Adventure",

  badge: "Leadership & Curriculum Design",
  title2: "Founder & Curriculum Director of Zabankid",
  subtitle2: "All course scenarios and teaching methods are designed by Mohammad Khaled Feyzi.",
  name: "Mohammad Khaled Feyzi",
  role: "Founder of zabankid & Curriculum Architect",
  bio: "Over 20 years of experience in language pedagogy, honored with international awards from Canada, Finland, Poland, and Romania.",
  achievements: [
    {
      text: "1st Place Winner at iCAN Canada World Invention Competition (Creativity in Education).",
      icon: "bi-trophy-fill",
      category: "cat-gold",
      tag: "International",
    },
    {
      text: "Certified in Entrepreneurial Child Education from University of Turku, Finland.",
      icon: "bi-mortarboard-fill",
      category: "cat-blue",
      tag: "Turku Finland",
    },
    {
      text: "Inventor of an innovative English writing methodology for kids (Registered in Canada).",
      icon: "bi-lightbulb-fill",
      category: "cat-purple",
      tag: "Innovation",
    },
    {
      text: "1st Place at the International Invention Show of Romania in Education Innovation.",
      icon: "bi-star-fill",
      category: "cat-gold",
      tag: "Romania",
    },
    {
      text: "1st Place at INTARG 2022 Poland in Education & Creativity.",
      icon: "bi-award-fill",
      category: "cat-gold",
      tag: "Poland 2022",
    },
    {
      text: "Honored by the World Invention Intellectual Property Associations (WIIPA - USA).",
      icon: "bi-shield-check",
      category: "cat-blue",
      tag: "WIIPA USA",
    },
    {
      text: "Author of 7 volumes of 'Joy Phonics' series for young learners (Rahnama Press).",
      icon: "bi-book-half",
      category: "cat-green",
      tag: "Author",
    },
    {
      text: "20+ Years of teaching & curriculum design experience in Tehran.",
      icon: "bi-calendar-check-fill",
      category: "cat-blue",
      tag: "20 Years",
    },
  ],


};
